import { MaintenanceTab, RoutingUrls } from '../../enums';
import { ACCOUNT_SHARED_ID, ACCOUNT_UNASSIGNED_ID } from '../common-config';
import { PageNamesGA } from './page-names-ga';

export const PathNamesGA = new Map([
  [RoutingUrls.Dashboard, PageNamesGA.Dashboard],
  [RoutingUrls.Accounts, PageNamesGA.Accounts],
  [ACCOUNT_UNASSIGNED_ID, PageNamesGA.UnassignedPacks],
  [ACCOUNT_SHARED_ID, PageNamesGA.SharedPacks],
  [RoutingUrls.Catalog, PageNamesGA.Catalog],
  ['products', PageNamesGA.Product],
  [RoutingUrls.Search, PageNamesGA.SearchResults],
  [RoutingUrls.Quotes, PageNamesGA.PackViews],
  [RoutingUrls.Prototypes, PageNamesGA.PackViews],
  [RoutingUrls.CompareProducts, PageNamesGA.CompareProducts],
  [MaintenanceTab.UsersManagement, PageNamesGA.AdminUserManagement],
  [MaintenanceTab.Pricing, PageNamesGA.AdminPricing],
  [MaintenanceTab.MassReplace, PageNamesGA.AdminMassReplace],
  [MaintenanceTab.Templates, PageNamesGA.AdminTemplates],
  [RoutingUrls.MasterTemplates, PageNamesGA.AdminMasterTemplateView],
  [MaintenanceTab.UnstagedPacks, PageNamesGA.AdminUnstagedPacks],
  [RoutingUrls.Profile, PageNamesGA.MyProfile],
]);
